export enum TaskAgreementStepEnum {
  /**
   * Запрос аренды
   * Новая заявка, общая информация из формы регистрации
   */
  TASK_STEP_INFO = 'INFO',
  /**
   * Коммерческое предложение
   * Согласование помещения
   */
  TASK_STEP_ROOM_AGREE = 'ROOM_AGREE',
  /**
   * Подбор помещения
   * Внутреннее согласование
   */
  TASK_STEP_ROOM = 'ROOM',
  /**
   * Подписание договора
   */
  TASK_STEP_CONTRACT = 'CONTRACT',
  /**
   * Согласование демонтажных работ
   */
  TASK_STEP_COORDINATION_DISMANTLING  = 'COORDINATION_DISMANTLING',
  /**
   * Согласование строительных работ
   */
  TASK_STEP_COORDINATION_CONSTRUCTION = 'COORDINATION_CONSTRUCTION',
  /**
   * Приемка работ и разрешение на открытие
   */
  TASK_STEP_ACCEPT_WORKS_AND_PERMISSION_OPEN = 'PERMISSION_OPEN',
}
